module.exports = __webpack_public_path__ + "img/img5578.d01ee0ec.jpg";